import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import HelpBox from 'components/generic/help/index';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'ComparisonsNormalReadabilityMeasures',

    propTypes: {
        studentBid: PropTypes.string.isRequired,
        lexileRange: PropTypes.string.isRequired,
    },

    helpText() {
        return (
            <div className="comparisons-normal-help-content" key="comparisons-readability-measures-normal-help-content">
                <p key="initial-text"> {CommonStrings.comparisonsReadabilityMeasuresHelp.initialText} </p>
            </div>
        );
    },

    render() {
        return (
            <div className="data-row" id={`comparisons-readability-measures-normal-${this.props.studentBid}`}>
                <h3 className="comparisons-heading">
                    READABILITY MEASURES
                    <span className="comparisons-heading-additional">
                        <HelpBox
                            id={'comparisons-readability-measures-normal-help-box-' + this.props.studentBid}
                            appLevelCssClassName="show-normal-comparisons-help-box"
                            helpContentsRenderer={this.helpText}
                            moduleName={CommonValues.SectionIDs.comparisons}
                            helpLabel="comparisons-readability-measures-normal-help"
                            optionalText="About ranges"
                        />
                    </span>
                </h3>
                <div className="readability-normal">
                    <div className="lexile">
                        Lexile*
                        <div
                            className="readability-data"
                            id={`comparisons-readability-data-normal-lexile-${this.props.studentBid}`}
                        >
                            {this.props.lexileRange}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});
